import React from 'react';

const ContentModerationAlert = ({ modelName, onDismiss }) => (
  <div className="content-moderation-alert">
    <div className="alert-content">
      <strong>
        The current model ({modelName}) declined this request due to content restrictions.
      </strong>
      <p>You can:</p>
      <ul>
        <li>Rephrase your message</li>
        <li>Switch to a more permissive model using the Model dropdown</li>
      </ul>
    </div>
    <button onClick={onDismiss} className="dismiss-button">
      Dismiss
    </button>
  </div>
);

export default ContentModerationAlert;
